import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { HeaderMetaNavModule } from '@hdms/shared/page-frame/ui';
import { ButtonModule, PreloaderModule, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { HeaderUserWrapperComponent } from './header-user-wrapper.component';

@NgModule({
  declarations: [HeaderUserWrapperComponent],
  imports: [
    CommonModule,
    ButtonModule,
    TranslationModule,
    SvgIconModule,
    PreloaderModule,
    HeaderMetaNavModule,
    AnalyticsModule
  ],
  exports: [HeaderUserWrapperComponent]
})
export class HeaderUserWrapperModule {}
